var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"common-box"},[_vm._t("title",function(){return [_c('TitleBar',_vm._b({},'TitleBar',_vm.$attrs,false))]}),_c('div',{staticClass:"common-content"},[_vm._t("default")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }